import { render } from "./CurrencyCalculator.vue?vue&type=template&id=5d056985"
import script from "./CurrencyCalculator.vue?vue&type=script&lang=js"
export * from "./CurrencyCalculator.vue?vue&type=script&lang=js"

import "./CurrencyCalculator.vue?vue&type=style&index=0&id=5d056985&lang=css"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__